<template>
	<div class="d-flex justify-space-between">
		<div class="d-flex flex-column">
			<h1 class="page-title">
				<slot name="header-title" />
			</h1>
			<span class="page-caption">
				<slot name="header-caption" />
			</span>
		</div>
		<div class="d-flex align-center">
			<!-- Product switch button (permission gated) -->
			<product-switch-button
				v-if="showProductSwitch"
			/>
			<!-- Shared user menu with preferences and logout -->
			<UserMenu
				class="ml-1"
				:user-full-name="userFullName"
			/>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProductSwitchButton from './product-switch-button.vue'
import UserMenu from './user-menu.vue'
import { hasMultipleProductAccess } from '../utils/product-access.js'
import { privacyNoticeModuleEnabled } from '../state/config-keys.js'

export default {
	components: {
		ProductSwitchButton,
		UserMenu
	},
	inject: {
		logOutAndRedirect: { default: () => () => {} },
		userFullName: { default: () => '' }
	},
	setup () {
		return {
			privacyNoticeModuleEnabled
		}
	},
	computed: {
		...mapGetters('auth', ['productAreaPermission']),
		showProductSwitch () {
			// Hide product switcher in CS Portal
			if (process.env.VUE_APP_TYPE === 'CS_PORTAL') return false

			const routeName = this.$route?.name
			if (routeName === 'splash') return false

			// Only show product switcher if user has access to multiple products
			return hasMultipleProductAccess(this.productAreaPermission, this.privacyNoticeModuleEnabled)
		}
	}
}
</script>

<style scoped lang="scss">
@import '../styles/_fonts.scss';

.page-title {
	// Page header title - Mont font, aligned with NextJS text-2xl (1.5rem / 24px)
	// Uses brand Mont font for visual prominence and consistency
	font-family: $heading-font-family; // Mont
	font-size: 1.5rem; // 24px - matches NextJS text-2xl
	font-weight: 700; // Bold
	line-height: 2rem; // 32px
	margin: 0;
	color: var(--global-header-text-color);
}

.page-caption {
	// Page header subtitle - Inter font, aligned with NextJS text-sm (0.875rem / 14px)
	// Uses content font for readability
	font-family: $content-font-family; // Inter
	font-size: 0.875rem; // 14px - matches NextJS text-sm
	font-weight: 400; // Regular
	line-height: 1.25rem; // 20px
	color: var(--global-muted-foreground);
	margin-top: 0.25rem;
}
</style>

<!-- Unscoped styles for user menu -->
<style lang="scss">
/* User menu button text - match main nav styling */
.v-btn.text-body-2 {
	font-size: 0.875rem !important;
	font-weight: 400 !important;
	letter-spacing: normal !important;
}

/* User menu dropdown items - match main nav styling */
.v-menu__content .v-list-item,
.v-menu__content .v-list-item__title {
	font-size: 0.875rem !important;
	font-weight: 400 !important;
	letter-spacing: normal !important;
}
</style>
